export default __webpack_public_path__ + "static/media/win.d92bc18f.gif";